import { render } from "./LazyLoadComponent.vue?vue&type=template&id=41405523&ts=true"
import script from "./LazyLoadComponent.vue?vue&type=script&lang=ts"
export * from "./LazyLoadComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__